import "./Retreats.module.css";
import Header from "@/reusable_sections/Header";
import RoomsOfSilence from "./sections/RoomsOfSilence";
import IhrRetreatAblauf from "./sections/IhrRetreatAblauf";
import AufDieWartelisteSetzen from "./sections/AufDieWartelisteSetzen";
import Abschluss from "@/reusable_sections/Footer";
export default function RetreatsPage() {
  return <div>
      <Header />
      <RoomsOfSilence />
      <IhrRetreatAblauf />
      <AufDieWartelisteSetzen />
      <Abschluss />
    </div>;
}